import { http } from '../utils/http';

// 保存总配置
export const reqCreateConfig = data =>
  http.request({
    timeout: '20000',
    url: `/config`,
    method: 'POST',
    data,
    withUserId: 'data'
  });

// 根据日志库查询已经保存的日志分析配置信息
export const reqFetchAnalysis = params =>
  http.request({
    url: `/config/analysis`,
    method: 'GET',
    params
  });

// 根据数据源 id 查询 CDN、Mysql 等通用的配置信息
export const reqFetchCommonConfig = params =>
  http.request({
    url: `/config/common`,
    method: 'GET',
    params
  });

// 查询Grok通用规则
export const reqFetchGrokDoc = params =>
  http.request({
    url: `/config/grok/doc`,
    method: 'GET',
    params
  });
